import CasinoTV from "../../components/CasinoTV.jsx";
import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
  uniCasinoBetAPI,
} from "../../service/casino/index.js";
import { useLocation, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions.jsx";
import PlaceBetUniversal from "./PlaceBetUniversal.jsx";
import GenericCasinoTimer from "../../components/GenericCasinoTimer.jsx";

export default function AmarAkhbarAnthony() {
  const { id: GAME_ID } = useParams();
  const haveLay = true;
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
 useEffect(() => {
   roundIdRef.current = odds?.roundId;
   setTimer(odds?.seconds);
   let interval = setInterval(() => {
     if (odds?.status == "SUSPEND" || timer <= 0) {
       setTimer(0);
     } else {
       setTimer((prev) => prev - 1);
     }
   }, 1000);

   return () => {
     clearInterval(interval);
   };
 }, [odds?.roundId]);
  const placeBet = async (
    marketIdWithSelectionId,
    runnerName,
    back,
    lay = false
  ) => {
    let payload = { ...placeBetPayload };
    payload.marketIdWithSelectionId = `${marketIdWithSelectionId}`;
    payload.runnerName = runnerName;
    payload.back = back;
    payload.marketId = odds?.roundId;
    payload.amount = 100;
    payload.type = "back";
    payload.casinoGames = GAME_ID;
    if (haveLay && lay) {
      payload.type = "lay";
      payload.lay = back;
      delete payload.back;
    }
    setPlaceBetPayload(payload);
  };
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await uniCasinoBetAPI(placeBetPayload);
    if (code === 200) {
      toast.success(status);
      getOdds();
      setPlaceBetPayload(null);
    } else {
      toast.error(response);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    // Add interval for time condition check
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  return (
    <div style={{ height: "780px", overflowY: "scroll" }}>
      <app-casino-room _ngcontent-ng-c663229740="" _nghost-ng-c2733776549="">
        <div
          _ngcontent-ng-c2733776549=""
          _ngcontent-ysg-c0=""
          id="playerInfo"
          className="top"
        >
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="left_list"
          />
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="right_list none-lobby-page hasTimer"
          >
            <ol _ngcontent-ng-c2733776549="" _ngcontent-ysg-c0="">
              <li _ngcontent-ng-c2733776549="" style={{ cursor: "pointer" }}>
                <i
                  _ngcontent-ng-c2733776549=""
                  _ngcontent-cuc-c0=""
                  className="fa fa-cog fa-lg"
                />
              </li>
            </ol>
          </div>
        </div>
        <div
          _ngcontent-ng-c2733776549=""
          id="stackbetsModal"
          aria-labelledby="stackbetsModal"
          aria-hidden="true"
          className="modal fade"
        >
          <div _ngcontent-ng-c2733776549="" className="modal-dialog">
            <div _ngcontent-ng-c2733776549="" className="modal-content">
              <div _ngcontent-ng-c2733776549="" className="modal-header">
                <h3 _ngcontent-ng-c2733776549="" className="mb-0 bold">
                  Stake
                </h3>
              </div>
              <div _ngcontent-ng-c2733776549="" className="stack-modal-body">
                <div
                  _ngcontent-ng-c2733776549=""
                  className="card-body container-fluid container-fluid-5 button-value quick-stake-container"
                >
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 desktop-pl"
                  >
                    <div _ngcontent-ng-c2733776549="" className="col-3">
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="button-title"
                        style={{ fontSize: 14, marginLeft: "-2px" }}
                      >
                        <span _ngcontent-ng-c2733776549="">
                          <b
                            _ngcontent-ng-c2733776549=""
                            className="stake-amount"
                          >
                            Quick Stakes
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 col-md-12 desktop-pl quick-stake-boxes"
                  >
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks0"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks1"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks2"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks3"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks4"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks5"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks6"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks7"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c2733776549="" className="modal-footer">
                  <button _ngcontent-ng-c2733776549="" className="updatebtn">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-casino-room>
      <router-outlet _ngcontent-ng-c663229740="" />
      <app-teenpatti _nghost-ng-c2991413133="">
        <div _ngcontent-ng-c2991413133="" style={{ overflowY: "hidden" }}>
          <div _ngcontent-ng-c2991413133="">
            <app-video-player
              _ngcontent-ng-c2991413133=""
              _nghost-ng-c595356512=""
            >
              <div _ngcontent-ng-c595356512="" className="videoPlayer">
                <CasinoTV casinoGames={GAME_ID} />

                <div _ngcontent-ng-c595356512="" className="video-overlay">
                  <div _ngcontent-ng-c595356512="">
                    <div
                      _ngcontent-ng-c595356512=""
                      className="round-id text-white"
                    >
                      RID: {odds?.roundId}
                    </div>

                    {odds?.playerCards?.map((player) => (
                      <div _ngcontent-ng-c595356512="">
                        <h3 _ngcontent-ng-c595356512="" className="text-white">
                          {player?.forPerson}
                        </h3>
                        <div _ngcontent-ng-c595356512="">
                          {player?.cards?.map((card) => (
                            <img
                              _ngcontent-ng-c595356512=""
                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {showWinnerOverlay && (
                  <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                    <div
                      _ngcontent-ng-c595356512=""
                      className="mini-result-new active"
                    >
                      <span _ngcontent-ng-c595356512="">
                        {" "}
                        {odds?.roundWinner} win{" "}
                      </span>
                      {/**/}
                    </div>
                    <span
                      _ngcontent-ng-c595356512=""
                      style={{ position: "absolute" }}
                    >
                      <canvas
                        _ngcontent-ng-c595356512=""
                        width="100vw"
                        height="100vh"
                      />
                    </span>
                    {/**/}
                  </div>
                )}

                <div _ngcontent-ng-c595356512="" className="timer-overlay">
                  <GenericCasinoTimer
                    time={odds?.seconds}
                    status={odds?.status}
                  />
                </div>
              </div>

              <div
                _ngcontent-ng-c595356512=""
                id="rulesModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabelaexampleModalLabela"
                aria-hidden="true"
                className="modal fade"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  className="modal-dialog rules-wrap"
                >
                  <div
                    _ngcontent-ng-c595356512=""
                    role="document"
                    id="rulesList___BV_modal_content_"
                    tabIndex={-1}
                    className="modal-content rules-content"
                  >
                    <header
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_header_"
                      className="rules-wrap"
                    >
                      <a _ngcontent-ng-c595356512="">
                        <h3
                          _ngcontent-ng-c595356512=""
                          id="rulesList___BV_modal_title_"
                          data-bs-toggle="modal"
                          data-bs-target="#rulesModal"
                          className="modal-title"
                        >
                          Rules
                        </h3>
                      </a>
                      <button
                        _ngcontent-ng-c595356512=""
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="close"
                      >
                        ×
                      </button>
                    </header>
                    <div
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_body_"
                      className="modal-body"
                    >
                      <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                    </div>
                    <div _ngcontent-ng-c595356512="">
                      <ul
                        _ngcontent-ng-c595356512=""
                        className="btn-wrap break"
                      >
                        <li _ngcontent-ng-c595356512="">
                          <a
                            _ngcontent-ng-c595356512=""
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="btnok"
                          >
                            OK
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </app-video-player>
          </div>
          <div
            _ngcontent-ng-c2991413133=""
            id="marketScroll"
            style={{ overflowY: "auto", height: 616 }}
            className="overflow-auto"
          >
            {odds?.markets?.map((item) =>
              ["ODD/EVEN"]?.includes(item?.marketName) ? (
                <div _ngcontent-ng-c1788957045="" className="container-fluid">
                  <div _ngcontent-ng-c1788957045="" className="row row5">
                    {odds?.markets
                      ?.filter((item) =>
                        ["ODD/EVEN", "COLOR", "UNDER/OVER"].includes(
                          item?.marketName
                        )
                      )
                      ?.map((item) => (
                        <div _ngcontent-ng-c1788957045="" className="col-4 p-0">
                          <div
                            _ngcontent-ng-c1788957045=""
                            className="light-bg pl-1 pr-1"
                          >
                            <div _ngcontent-ng-c1788957045="" className="card">
                              {odds?.status == "SUSPEND" && (
                                <div
                                  _ngcontent-ng-c2991413133=""
                                  className="suspended-casino"
                                >
                                  <span
                                    _ngcontent-ng-c2991413133=""
                                    className="stats-text"
                                  >
                                    Suspended
                                  </span>
                                </div>
                              )}
                              <span
                                _ngcontent-ng-c1788957045=""
                                data-bs-toggle="collapse"
                                data-bs-target="#multiCollapseExample2"
                                role="button"
                                aria-expanded="true"
                                aria-controls="multiCollapseExample2"
                                className="btn btn-primary card-header inner-sportbook"
                              >
                                <span _ngcontent-ng-c1788957045="">
                                  <strong _ngcontent-ng-c1788957045="">
                                    {item?.marketName}
                                  </strong>
                                </span>
                                <span _ngcontent-ng-c1788957045="" />
                              </span>
                              <div _ngcontent-ng-c1788957045="" className="col">
                                <div
                                  _ngcontent-ng-c1788957045=""
                                  id="multiCollapseExample2"
                                  className="collapse multi-collapse show"
                                >
                                  <table
                                    _ngcontent-ng-c1788957045=""
                                    className="table table-hover tbl-bets p-rltv sportbook-market-tbl"
                                  >
                                    <tbody>
                                      <tr _ngcontent-ng-c1788957045="">
                                        <th
                                          _ngcontent-ng-c1788957045=""
                                          colSpan=""
                                          className="min-max-mobile"
                                        >
                                          <dl
                                            _ngcontent-ng-c1788957045=""
                                            id="minMaxBox"
                                            className="fancy-info"
                                          >
                                            <dt _ngcontent-ng-c1788957045="">
                                              Min/Max{" "}
                                            </dt>
                                            <dd
                                              _ngcontent-ng-c1788957045=""
                                              id="minMaxInfo"
                                            >
                                              {" "}
                                              {item?.min} - {item?.max}{" "}
                                            </dd>
                                          </dl>
                                        </th>
                                      </tr>

                                      {item?.oddDetailsDTO?.map((odd, i) => (
                                        <tr _ngcontent-ng-c1788957045="">
                                          <td
                                            onClick={() =>
                                              placeBet(
                                                `${item?.marketId}_${odd?.selectionId}`,
                                                odd?.runnerName,
                                                odd?.back1
                                              )
                                            }
                                            _ngcontent-ng-c1788957045=""
                                            colSpan=""
                                            className={`d-flex flex-column ${
                                              i >= 1
                                                ? "smallBoxBlue"
                                                : "smallBoxRed"
                                            }`}
                                          >
                                            {" "}
                                            {odd?.runnerName}{" "}
                                            <span
                                              _ngcontent-ng-c1788957045=""
                                              className="p-0"
                                            >
                                              {odd?.back1}
                                            </span>
                                            <span
                                              _ngcontent-ng-c1788957045=""
                                              className="p-0 span-size"
                                            >
                                              {odd?.backSize1}
                                            </span>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>

                  <div>
                    {odds?.markets
                      ?.filter((item) =>
                        ["ODD/EVEN", "COLOR", "UNDER/OVER"].includes(
                          item?.marketName
                        )
                      )
                      ?.map((item) =>
                        item?.oddDetailsDTO?.map(
                          (odd, i) =>
                            placeBetPayload?.marketIdWithSelectionId ==
                              `${item?.marketId}_${odd?.selectionId}` && (
                              <PlaceBetUniversal
                                placeBetPayload={placeBetPayload}
                                setPlaceBetPayload={setPlaceBetPayload}
                                placeBet={placeBetCallApi}
                              />
                            )
                        )
                      )}
                  </div>
                  <div
                    _ngcontent-ng-c1788957045=""
                    className="row row5 p-0"
                  ></div>
                </div>
              ) : (
                !["COLOR", "UNDER/OVER", "ODD/EVEN"].includes(
                  item?.marketName
                ) && (
                  <div _ngcontent-ng-c2991413133="" className="card">
                    <span
                      _ngcontent-ng-c2991413133=""
                      className="btn btn-primary card-header inner-sportbook"
                    >
                      <span
                        _ngcontent-ng-c2991413133=""
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="true"
                        aria-controls="multiCollapseExample1"
                        className="minmax"
                        data-bs-target="#multiCollapseExample9151202184454"
                      >
                        <strong _ngcontent-ng-c2991413133="">
                          {item?.marketName}
                        </strong>
                      </span>
                      <div
                        _ngcontent-ng-c2991413133=""
                        className="minMaxDesktop"
                      >
                        <span _ngcontent-ng-c2991413133="">
                          Min/Max: {item?.min} - {item?.max}
                        </span>
                      </div>
                      <span
                        _ngcontent-ng-c2991413133=""
                        className="minMaxMobile"
                      >
                        <i
                          _ngcontent-ng-c2991413133=""
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          className="fa fa-info-circle ml-2"
                          data-bs-target="#multiCollapseExample9151202184454"
                          id="#collapse129151202184454"
                        />
                        <ul
                          _ngcontent-ng-c2991413133=""
                          className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                          aria-labelledby="collapse129151202184454"
                        >
                          <span _ngcontent-ng-c2991413133="">
                            Min/Max: {item?.min} - {item?.max}
                          </span>
                        </ul>
                      </span>
                    </span>
                    <div _ngcontent-ng-c2991413133="" className="col">
                      <div
                        _ngcontent-ng-c2991413133=""
                        className="collapse multi-collapse show"
                        id="multiCollapseExample9151202184454"
                      >
                        <table
                          _ngcontent-ng-c2991413133=""
                          className="table table-hover tbl-bets p-rltv sportbook-market-tbl"
                        >
                          <tbody>
                            {item?.marketName?.toLowerCase() == "winner" && (
                              <tr _ngcontent-ng-c1788957045="">
                                <th
                                  _ngcontent-ng-c1788957045=""
                                  colspan=""
                                  class="min-max-mobile"
                                >
                                  <dl
                                    _ngcontent-ng-c1788957045=""
                                    id="minMaxBox"
                                    class="fancy-info"
                                  >
                                    <dt _ngcontent-ng-c1788957045="">
                                      Min/Max &nbsp;
                                    </dt>
                                    <dd
                                      _ngcontent-ng-c1788957045=""
                                      id="minMaxInfo"
                                    >
                                      {" "}
                                      100 - 100000{" "}
                                    </dd>
                                  </dl>
                                </th>
                                <th
                                  _ngcontent-ng-c1788957045=""
                                  class="back-1"
                                  style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Back
                                </th>
                                <th
                                  _ngcontent-ng-c1788957045=""
                                  class="lay"
                                  style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Lay
                                </th>
                              </tr>
                            )}
                            {item?.oddDetailsDTO?.map((odd) => (
                              <>
                                <tr
                                  _ngcontent-ng-c2991413133=""
                                  className="odd-row"
                                >
                                  <td
                                    _ngcontent-ng-c2991413133=""
                                    colSpan=""
                                    className="team-name sportbook-name"
                                    style={{ width: "70%" }}
                                  >
                                    <span
                                      _ngcontent-ng-c2991413133=""
                                      className="title"
                                    >
                                      {item?.marketName?.split(" ")[
                                        item?.marketName?.split(" ")?.length - 1
                                      ] == "CARD" ? (
                                        <img
                                          src={`https://casino.queenexch.com/assets/t10cards/${odd?.runnerName}.jpeg`}
                                          style={{ width: 30 }}
                                        />
                                      ) : (
                                        odd?.runnerName
                                      )}
                                    </span>
                                    {getUniversalCasinoPlExposureByRunner(
                                      exposure,
                                      odd?.runnerName
                                    )}
                                    <div
                                      _ngcontent-ng-c2991413133=""
                                      className="d-flex align-items-center p-0"
                                    ></div>
                                  </td>
                                  {/* <div _ngcontent-ng-c3053379241="" class="spnd-casinouniqueLay"><span _ngcontent-ng-c3053379241="" class="stats-text">Suspendeds</span></div> */}
                                  <td
                                    onClick={() =>
                                      placeBet(
                                        `${item?.marketId}_${odd?.selectionId}`,
                                        odd?.runnerName,
                                        odd?.back1
                                      )
                                    }
                                    _ngcontent-ng-c2991413133=""
                                    appratehighlight=""
                                    className={`back-1 count sportbook-minwidth p-rltv ${
                                      odd?.runnerName ==
                                        placeBetPayload?.runnerName &&
                                      placeBetPayload?.type == "back"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <a
                                      _ngcontent-ng-c2991413133=""
                                      className="d-flex flex-column p-0"
                                      style={{ textDecoration: "none" }}
                                    >
                                      {odd?.back1}
                                      <span
                                        _ngcontent-ng-c2991413133=""
                                        className="d-flex justify-content-center"
                                      >
                                        {odd?.backSize1}
                                      </span>
                                    </a>
                                  </td>
                                  {haveLay && odd?.lay1 && (
                                    <td
                                      onClick={() =>
                                        placeBet(
                                          `${item?.marketId}_${odd?.selectionId}`,
                                          odd?.runnerName,
                                          odd?.lay1,
                                          true
                                        )
                                      }
                                      _ngcontent-ng-c2991413133=""
                                      appratehighlight=""
                                      className={`lay-1 count sportbook-minwidth p-rltv ${
                                        odd?.runnerName ==
                                          placeBetPayload?.runnerName &&
                                        placeBetPayload?.type == "lay"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <a
                                        _ngcontent-ng-c2991413133=""
                                        className="d-flex flex-column p-0"
                                        style={{ textDecoration: "none" }}
                                      >
                                        {odd?.lay1}
                                        <span
                                          _ngcontent-ng-c2991413133=""
                                          className="d-flex justify-content-center"
                                        >
                                          {odd?.laySize1}
                                        </span>
                                      </a>
                                    </td>
                                  )}
                                </tr>
                                {placeBetPayload?.marketIdWithSelectionId ==
                                  `${item?.marketId}_${odd?.selectionId}` && (
                                  <PlaceBetUniversal
                                    placeBetPayload={placeBetPayload}
                                    setPlaceBetPayload={setPlaceBetPayload}
                                    placeBet={placeBetCallApi}
                                  />
                                )}
                              </>
                            ))}
                            {odds?.status == "SUSPEND" && (
                              <div
                                _ngcontent-ng-c2991413133=""
                                className="suspended-casino"
                              >
                                <span
                                  _ngcontent-ng-c2991413133=""
                                  className="stats-text"
                                >
                                  Suspended
                                </span>
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )
              )
            )}

            <GetUniversalLastTenResult lastResult={lastResult} />
          </div>
        </div>
      </app-teenpatti>
    </div>
  );
}
